// @flow
import React, { Component } from 'react';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl, Table, Label } from 'react-bootstrap';
import firebase from 'firebase';
import Loading from '../../components/Loading';

type IProps = {
  users: Array<Object>,
  lessons: Array<Object>,
  room: string,
  section: Object,
}

type IState = {
  data: Object,
  user: number,
}

class ListUser extends Component {  

  constructor(props: IProps) {
    super(props);

    this.state = {
      data: {},
      user: 0,
      loading: true,
    };
  }

  state: IState;

  componentDidMount() {
    this.reload();
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    if (this.props.section.id !== prevProps.section.id) {
      this.reload();
    }
  }
  
  reload() {
    this.setState(
      {
        loading: true,
      },
      () => {
        const { room, users, section } = this.props;
        const { user } = this.state;
        const uid = users[user].uid;
        
        firebase.database()
        .ref(`room/${room}/${section.statistics}`)
        .orderByChild(`user`)
        .equalTo(uid)
        .on('value', (snapshot) => {
          this.setState({
            data: snapshot.val() || {},
            loading: false,
          });
        });
      },
    );
  }
  
  handleSelectUser(e: Object) {
    this.setState(
      {
        user: e.target.value,
      },
      this.reload,
    );
  }
  
  props: IProps;

  render() {
    const { users, lessons } = this.props;
    const { data } = this.state;

    let valid = 0;
    let total = 0;

    const itemsInArray = [];
    Object.keys(data).forEach((key) => {
      const item = data[key];
      total += 1;
      if (item.valid || item.accepted) {
        valid += 1;
      }
      itemsInArray.push(item)
    });
    const sortedData = itemsInArray.sort((a, b) => a.date < b.date ? 1 : -1);

    const percentage = parseInt((valid / total) * 100);
    let style = "success";
    if (percentage < 70) {
      style = "warning";
    }
    if (percentage < 40) {
      style = "danger";
    }

    return (
      <div>
        <hr />
        <Row style={{ marginBottom: '30px' }}>
          <Col xs={12} sm={4}>
            <FormGroup controlId="user">
              <ControlLabel>User</ControlLabel>
              <FormControl componentClass="select" placeholder="select" onChange={(e) => { this.handleSelectUser(e); }}>
                {
                  users.map((user, index) => {
                    const key = Object.keys(users)[index];
                    return (
                      <option key={key} value={index}>{`${user.name} (${user.email})`}</option>
                    );
                  })
                }
              </FormControl>
            </FormGroup>
            <h3>
              <Label bsStyle="success">{valid}x</Label>&nbsp;
              <Label bsStyle="danger">{total - valid}x</Label>&nbsp;
              {
                total > 0 && <Label bsStyle={style}>{percentage} %</Label>
              }
            </h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Table striped bordered condensed hover>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Original</th>
                  <th>Answer</th>
                  <th>Valid</th>
                </tr>
              </thead>
              <tbody>
                {
                  sortedData.map((item) => {
                    const date = new Date(item.date);
                    return (
                      <tr key={date}>
                        <td>{date.getDate()}. {date.getMonth() + 1}. {date.getFullYear()} {date.getHours()}:{date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}</td>
                        <td>{item.original}</td>
                        <td>{item.value}</td>
                        <td>
                          {
                            item.valid
                            ? <Label bsStyle="success">Valid</Label>
                            : (
                              item.accepted
                              ? <Label bsStyle="primary">Accepted</Label>
                              : <Label bsStyle="danger">Wrong</Label>
                            )
                          }
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ListUser;


// WEBPACK FOOTER //
// ./src/pages/Statistics/ListUser.js